interface IUserModel {
	name: string;
	uid: string;
	email: string;
	picture: string;
	status: boolean;
	roll: IUserRollType;
	pushTokens: string[];
}

type IUserRollType = 0 | 1;

const defaultUser: IUserModel = {
	name: '',
	uid: '',
	email: '',
	picture: '',
	status: false,
	roll: 0,
	pushTokens: []
};

export default IUserModel;
export { defaultUser, IUserRollType };
